import isDocument from './isDocument';
export default function isWindow(node) {
  if ('window' in node && node.window === node) return node;
  if (isDocument(node)) return node.defaultView || false;
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-helpers/esm/isWindow.js
// module id = 624
// module chunks = 0